import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Row from '../utils/Row'
import Col from '../utils/Col'
import DatePicker from 'component/utils/DatePicker'
import Form from 'component/utils/Form'
import Field from '../utils/Field'
import moment from 'moment'
import Select from 'react-select/creatable'
import { typeLogList } from './typeLogList'
import { formatHour } from 'utils/masks'
import Input from 'component/utils/Input'

const FIELDS = [
  'dtEnd',
  'dtStart',
  'logType',
  'hourStart',
  'hourEnd',
  'filterNumber',
]

class Filter extends Component {
  static propTypes = {
    translate: PropTypes.func,
    filters: PropTypes.object,
    fields: PropTypes.object,
    setValueToField: PropTypes.func,
    handleSubmit: PropTypes.func,
    stretchedOut: PropTypes.bool,
    initialValues: PropTypes.object,
    values: PropTypes.object.isRequired,
  }

  componentDidMount() {
    const { filters, setValueToField, translate } = this.props

    if (filters) {
      let option = {
        value: 1,
        label: translate('totem.query.log.sales.order.number.option'),
      }

      if (filters.logType) {
        const logType = typeLogList.find(
          (option) => option.type === filters.logType
        )
        option = { value: logType.type, label: translate(logType.label) }
      }

      setValueToField('logType', option)
      setValueToField(
        'dtStart',
        filters.dtStart ? moment(filters.dtStart).add(3, 'hours') : ''
      )
      setValueToField(
        'dtEnd',
        filters.dtEnd ? moment(filters.dtEnd).add(3, 'hours') : ''
      )
      setValueToField('hourStart', filters.hourStart)
      setValueToField('hourEnd', filters.hourEnd)
      setValueToField(
        'filterNumber',
        filters.orderNumber || filters.documentNumber
      )
    }
  }

  submit = () => {
    const { handleSubmit, fields } = this.props

    const filters = {
      dtStart: fields.dtStart.input.value
        ? fields.dtStart.input.value._d
        : null,
      dtEnd: fields.dtEnd.input.value ? fields.dtEnd.input.value._d : null,
      logType: fields.logType.input.value
        ? fields.logType.input.value.value
        : 1,
      hourStart: fields.hourStart.input.value,
      hourEnd: fields.hourEnd.input.value,
    }

    const { value } = fields.filterNumber.input
    const type = fields.logType.input.value.value

    switch (type) {
      case 1:
      case 3:
      case 4:
      case 5:
        filters.orderNumber = value ? value.trim() : ''
        break

      case 2:
        filters.documentNumber = value ? value.replace(/[^a-zA-Z0-9]/g, '') : ''
        break

      default:
        break
    }

    handleSubmit(filters)
  }

  setHour = (field, value) => {
    const { setValueToField } = this.props
    setValueToField(field, formatHour(value))
  }

  verifyButton = () => {
    const { fields } = this.props

    const datesCondition =
      !fields.dtStart.input.value ||
      !fields.dtEnd.input.value ||
      !fields.logType.input.value
    const onCondition =
      !fields.filterNumber.input.value || !fields.logType.input.value

    return datesCondition && onCondition
  }

  renderOptions = () =>
    typeLogList.map((option) => ({
      value: option.type,
      label: this.props.translate(option.label),
    }))

  get filterFieldName() {
    const {
      translate,
      fields: {
        logType: {
          input: { value },
        },
      },
    } = this.props

    switch (value.value) {
      case 1:
      case 3:
      case 4:
      case 5:
        return translate('query.logs.orderNumber')

      case 2:
        return translate('query.logs.documentNumber')

      default:
        return ''
    }
  }

  render() {
    const { fields, translate, setValueToField, stretchedOut, values } =
      this.props

    return (
      <form className='margin-top-double margin-bottom-double'>
        <Row>
          <div className={`${stretchedOut ? 'filtered-in-table' : ''}`}>
            <Col className='totem-query-logs-filter'>
              <Field
                {...fields.logType}
                hint={translate('query.logs.functionality')}
              >
                <Select
                  className='react-select'
                  classNamePrefix='react-select'
                  formatCreateLabel={(string) =>
                    `${translate('query.logs.functionality')} ${string}`
                  }
                  id='logType'
                  menuPortalTarget={document.body}
                  name='logType'
                  onChange={(option) => setValueToField('logType', option)}
                  options={this.renderOptions()}
                  placeholder=''
                  isClearable='true'
                  styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                  value={values.logType}
                />
              </Field>
            </Col>
            <Col className='totem-query-logs-filter'>
              <Field {...fields.filterNumber} hint={this.filterFieldName}>
                <Input
                  {...fields.filterNumber.input}
                  id='filterNumber'
                  maxLength={18}
                />
              </Field>
            </Col>
            <Col className='totem-query-logs-filter'>
              <Field
                {...fields.dtStart}
                glyph='glyph glyph-calendar'
                hint={translate('query.logs.dtStart')}
              >
                <DatePicker
                  {...fields.dtStart.input}
                  placeholder={translate('query.logs.placeholder.start')}
                  showClearDate
                  isOutsideRange={(date) =>
                    moment(date).isAfter(fields.dtEnd.input.value)
                  }
                />
              </Field>
            </Col>
            <Col className='totem-query-logs-filter'>
              <Field
                {...fields.dtEnd}
                glyph='glyph glyph-calendar'
                hint={translate('query.logs.dtEnd')}
              >
                <DatePicker
                  {...fields.dtEnd.input}
                  placeholder={translate('query.logs.placeholder.end')}
                  showClearDate
                  isOutsideRange={(date) =>
                    moment(date).isBefore(fields.dtStart.input.value)
                  }
                />
              </Field>
            </Col>
            <div style={{ display: 'inline-flex', width: '100%' }}>
              <Col style={{ width: '100%' }}>
                <Field
                  glyph='glyph glyph-clock'
                  {...fields.hourStart}
                  hint={translate('query.logs.hourStart')}
                >
                  <Input
                    {...fields.hourStart.input}
                    id='hourStart'
                    maxLength={5}
                    onChange={(option) =>
                      this.setHour('hourStart', option.target.value)
                    }
                  />
                </Field>
              </Col>
              <Col style={{ width: '100%', marginLeft: '5%' }}>
                <Field
                  glyph='glyph glyph-clock'
                  {...fields.hourEnd}
                  hint={translate('query.logs.hourEnd')}
                >
                  <Input
                    {...fields.hourEnd.input}
                    id='hourEnd'
                    maxLength={5}
                    onChange={(option) =>
                      this.setHour('hourEnd', option.target.value)
                    }
                  />
                </Field>
              </Col>
            </div>

            <Col className='totem-query-logs-filter-button'>
              <button
                type='button'
                className='button button-primary button-full'
                disabled={this.verifyButton()}
                role='button'
                onClick={() => this.submit()}
              >
                {translate('filter_button_label')}
              </button>
            </Col>
          </div>
        </Row>
      </form>
    )
  }
}

export default Form({ fields: FIELDS })(Filter)
